import { useSelector } from 'react-redux';

import { getIsMarketGraphsEnabled, getPNCEnabledSetting } from 'redux/modules/appConfigs/selectors';
import { getIsMarketClosed, getMarketPricesIsSelectionNonRunner } from 'redux/modules/marketsPrices/selectors';

export const useMarketGraphIcon = ({
  marketId,
  selectionId,
  handicap
}: {
  marketId: string;
  selectionId: number | string;
  handicap?: number | string;
}) => {
  const isPNCEnabled = useSelector(getPNCEnabledSetting);
  const isMarketClosed = useSelector(getIsMarketClosed(marketId));
  const isMarketGraphEnabled = useSelector(getIsMarketGraphsEnabled);
  const isNonRunner = useSelector(getMarketPricesIsSelectionNonRunner(marketId, +(selectionId ?? 0), +(handicap ?? 0)));

  return !isMarketClosed && !isNonRunner && !isPNCEnabled && isMarketGraphEnabled;
};
